import { AlertTriangle, ArrowRight } from 'lucide-react'

import { Alert, AlertAction, AlertDescription, AlertTitle } from '@/customer/components/ui/alert'
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/customer/components/ui/dialog'
import { Link } from '@/customer/components/ui/link'
import type { AccountIssue } from '@/customer/lib/membership'

export function BlockedActionDialog({
  open,
  onOpenChange,
  blockers,
  title = 'Before you book',
  description = 'A few things need attention before you can book a visit.',
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  blockers: AccountIssue[]
  title?: string
  description?: string
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader tone="yellow">
          <AlertTriangle className="size-6" />
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <p>{description}</p>
          <ul className="flex flex-col gap-3">
            {blockers.map((blocker) => (
              <li key={`${blocker.type}:${blocker.action.href}`}>
                <Alert variant="neutral">
                  <AlertTitle>{blocker.title}</AlertTitle>
                  {blocker.description ? (
                    <AlertDescription className="text-fine-print">
                      {blocker.description}
                    </AlertDescription>
                  ) : null}
                  <AlertAction>
                    <Link
                      to={blocker.action.href}
                      className="group flex items-center gap-1 text-button-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
                    >
                      {blocker.action.label ?? blocker.title}
                      <ArrowRight
                        className="size-3 transition-transform group-hover:translate-x-0.5"
                        aria-hidden
                      />
                    </Link>
                  </AlertAction>
                </Alert>
              </li>
            ))}
          </ul>
        </DialogBody>
      </DialogContent>
    </Dialog>
  )
}
